import { Component, OnInit, Input } from '@angular/core';
import { PaymentGatewayService } from '../../services/payment-gateway.service';
import { PaymentContext, StripePaymentDetails } from '../../interfaces/payment-gateway.interface';

@Component({
  selector: 'app-stripe-redirect',
  template: `
    <div class="stripe-redirect text-center py-5">
      <ng-container *ngIf="isLoading">
        <div class="spinner-border text-primary mb-3" role="status"></div>
        <p class="text-muted">Redirecting to secure Stripe checkout...</p>
      </ng-container>
      <div *ngIf="errorMessage" class="alert alert-danger">
        {{ errorMessage }}
        <button class="btn btn-sm btn-outline-danger ml-2" (click)="redirect()">Retry</button>
      </div>
    </div>
  `
})
export class StripeRedirectComponent implements OnInit {
  @Input() context: PaymentContext = PaymentContext.ADHOC_INVOICE;
  @Input() paymentDetails: Partial<StripePaymentDetails> = {};

  isLoading    = false;
  errorMessage = '';

  constructor(private paymentGatewayService: PaymentGatewayService) {}

  async ngOnInit(): Promise<void> {
    await this.redirect();
  }

  async redirect(): Promise<void> {
    this.isLoading    = true;
    this.errorMessage = '';
    try {
      await this.paymentGatewayService.redirectToStripeCheckout({
        ...this.paymentDetails,
        context:   this.context,
        timestamp: Date.now()
      });
      // Browser navigates away — no code runs after this
    } catch (err: any) {
      this.errorMessage = err?.message || 'Failed to redirect to Stripe payment';
      this.isLoading    = false;
    }
  }
}
